import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import Translator from "../../components/i18nComponents/Translator";

function PaymentOk() {

  return (
    <Container maxWidth="sm">
      <Box mt={5} textAlign="center">
        <Typography variant="h4" component="h1" gutterBottom>
          <Translator path="paginas.buyRobot.payoktitle" />
        </Typography>
        <Typography variant="body1">
          <Translator path="paginas.buyRobot.payokmsg" />
        </Typography>
      </Box>
    </Container>
  );
}

export default PaymentOk;
